import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import WrapTextIcon from '@material-ui/icons/WrapText';
//import Conexao from '../providers/Conexao'
import Swal from 'sweetalert2'
import {withRouter} from 'react-router-dom'
import {Tooltip, Grid, Divider, TextField} from '@material-ui/core'
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';



const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const WebClientesModalNovoEquipamento = (props) => {
    const [open, setOpen] = React.useState(false)

    const handleClickOpen = () =>{
        setOpen(true)
    }

    const handleClose = () =>{
        setOpen(false)
    }
  return (
    <div>
      <Tooltip title='Cadastrar um novo veículo'>
          <Fab color='primary' onClick={handleClickOpen} style={{cursor:'pointer'}}>
              <AddIcon/>
          </Fab>
        
      </Tooltip>
      <Dialog 
        disableBackdropClick disableEscapeKeyDown
        hideBackdrop
        fullWidth
        maxWidth='sm'
        onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
         Cadatro de Novo Equipamento
        </DialogTitle>
        <DialogContent dividers >
         <Grid container spacing={1}>
            <Grid item xs = {3}>
                <Typography variant='subtitle1'>Número Série</Typography>
            </Grid>
            <Grid item xs = {6}>
                <TextField
                    variant='outlined'
                    size='small'
                    fullWidth
                    InputLabelProps={{shrink:true}} />
            </Grid>
         </Grid>

         <Grid container spacing={1} style={{marginTop : '5px'}}>
            <Grid item xs = {3}>
                <Typography variant='subtitle1'>Marca</Typography>
            </Grid>
            <Grid item xs = {9}>
                <TextField
                    variant='outlined'
                    size='small'
                    fullWidth
                    InputLabelProps={{shrink:true}} />
            </Grid>
         </Grid>

         <Grid container spacing={1} style={{marginTop : '5px'}}>
            <Grid item xs = {3}>
                <Typography variant='subtitle1'>Modelo</Typography>
            </Grid>
            <Grid item xs = {9}>
                <TextField
                    variant='outlined'
                    size='small'
                    fullWidth
                    InputLabelProps={{shrink:true}} />
            </Grid>
         </Grid>

         <Grid container spacing={1} style={{marginTop : '5px'}}>
            <Grid item xs = {3}>
                <Typography variant='subtitle1'>Contador Mono</Typography>
            </Grid>
            <Grid item xs = {3}>
                <TextField
                    variant='outlined'
                    size='small'
                    fullWidth
                    InputLabelProps={{shrink:true}} />
            </Grid>
         </Grid>
         <Grid container spacing={1} style={{marginTop : '5px'}}>
            <Grid item xs = {3}>
                <Typography variant='subtitle1'>Contador Color</Typography>
            </Grid>
            <Grid item xs = {3}>
                <TextField
                    variant='outlined'
                    size='small'
                    fullWidth
                    InputLabelProps={{shrink:true}} />
            </Grid>
         </Grid>
         <Grid container spacing={1} style={{marginTop : '5px'}}>
            <Grid item xs = {3}>
                <Typography variant='subtitle1'>Contador Total</Typography>
            </Grid>
            <Grid item xs = {3}>
                <TextField
                    variant='outlined'
                    size='small'
                    fullWidth
                    InputLabelProps={{shrink:true}} />
            </Grid>
         </Grid>


        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} variant='outlined' color="secondary">
            Cancelar
          </Button>
          <Button autoFocus onClick={handleClose} variant='contained'  color="primary">
            Gravar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


export default withRouter(WebClientesModalNovoEquipamento)